module.exports = __webpack_public_path__ + "media/images/backgrounds/ballistix-home-aada0414d7ea46f5662c8ee9a1994932c2b8781a9dd704fb3c743afa5adddbef.jpg";